import Vue from 'vue';
import TIM from 'tim-js-sdk';
import { decodeText } from '@/putils/decodeText';
import i18n from '@/locales/i18n';
import { mapState,mapGetters,mapActions } from 'vuex';
import { emojiMap, emojiName, emojiUrl } from '@/putils/emojiMap';
import { LIVE_STAGE } from '@/constants/room';
import { Loading } from 'element-ui';
import {
  UPDATE_SWITCH_VOTE,
  UPDATE_VOTE_LTST
} from '@/constants/mutation-types';

export default {
  data() {
    return {
      $tim:null,
      isSdkReady: false,
      inputMsg: '',
      imdLogin:false,
      popoverVisible: false,
      isNotExistRoom: false,
      emojiMap,
      emojiName,
      emojiUrl,
      loadingInstance:null,
      messageList: [], // 消息列表
      muteUserIdList: [], // 被禁言的用户ID列表
      lockey:{
        userId:""
    },
    };
  },
  computed: {
    ...mapState({
      sdkAppId: 'sdkAppId',
      userSig: state => state.userInfo.userSig,
      liveStage: 'liveStage',
      userInfo: 'userInfo',
      roomInfo: 'roomInfo',
      roomId: state => state.roomInfo.roomId,
      roomName: state => state.roomInfo.roomName,
      anchorUserId: state => state.anchorUserInfo.anchorUserId,
      switchVote: 'switchVote',
    }),
    ...mapGetters(["get_imMessageList",'get_voteList']),
    groupID() {
      if(this.roomInfo.roomStatus=='live_over' || this.roomInfo.roomStatus=='live_pause' || this.roomInfo.roomStatus=='no_live'){
        console.log(this.roomId.toString()+'_playback');
        return this.roomId.toString()+'_playback';
      }else{
        return this.roomId.toString();
      }
      
    },
    userData() {
      let userVo = {
        sdkAppId: this.sdkAppId,
        userSig: this.userSig,
        userId: this.userInfo.userId,
        imUserId: this.userInfo.imUserId,
      };
      return userVo;
    },
    isLiveEnded() {
      return this.liveStage === LIVE_STAGE.ENDED;
    },
    // 客户未登录时展示登录提示
    showLoginAttention() {
      return !this.userInfo || !this.userSig;
    },
    inputPlaceHolder() {
      return this.showLoginAttention ? '' : this.$t('Type a message');
    },
  },
  watch: {
    sdkAppId: {
      immediate: true,
      async handler() {
        await this.createSkd();
      },
    },
    userData: {
      immediate: true,
      async handler(val) {
        const { userSig, userId } = val;
        if (userId && userSig) {
          await this.loginTim();
          await this.handleTimEvents();
          this.loadingInstance = Loading.service({ fullscreen: true, lock: true, text: '' });
        }
      },
    },
    // 发出一条新消息，自动到最底部
    messageList() {
      this.$nextTick(() => {
        const msg = this.$refs.box;
        msg.scrollTop = msg.scrollHeight;
      });
    },
  },
  methods: {
    ...mapActions(["call_imMessage",'call_voteList','call_hotOnline','call_playback','call_liveScene']),
    // 获取用户昵称
    getUserNick({ nick, userID }) {
      return nick ? nick : userID;
    },
    // 是否是主播的消息
    isAnchorMessage({ userID }) {
      return userID === this.anchorUserId;
    },
    //初始化sdk
    async createSkd(){
      if (!this.$tim) {
        // Vue.prototype.$tim = TIM.create({ SDKAppID: this.sdkAppId, });
        this.$tim = TIM.create({ SDKAppID: this.sdkAppId});
        this.$tim.setLogLevel(1);
        if (this.userInfo.userId && this.userInfo.userSig) {
          // let resuser = await this.loginTim();
          // this.handleTimEvents();
          // this.imdLogin = true;
        }
      }
    },
    // 获取消息时间
    getMessageTime({ time }) {
      let hour = new Date(time * 1000).getHours();
      let minute = new Date(time * 1000).getMinutes();
      hour = hour >= 10 ? hour.toString() : `0${hour}`;
      minute = minute >= 10 ? minute.toString() : `0${minute}`;
      return `${hour}:${minute}`;
    },
    // 发送消息
    handleSendMsg() {
      if (this.showLoginAttention || this.inputMsg === '' || /^\s+$/gi.test(this.inputMsg)) {
        return;
      }
      this.sendMessage(this.inputMsg);
      this.inputMsg = '';
      this.popoverVisible = false;
    },
    // 选择表情
    chooseEmoji(item) {
      if (this.showLoginAttention) {
        return;
      }
      this.inputMsg += item;
      !this.$isMobile && this.$refs.input.focus();
    },
    // 处理登录
    handleLogin() {
      this.$eventBus.$emit('showLoginCard');
    },
    // --------- TIM 登录登出 ---------
    // 登录即时通信 IM
    async loginTim() {
      console.log("----------------userID 观众端  录即时通信-------------------");
      try {
        let mdata = await this.$tim.login({ userID: this.userInfo.userId, userSig: this.userSig});
        if (mdata.data.repeatLogin === true) {
          console.log(mdata.data.errorInfo);
        }
        return mdata;
      } catch (imError) {
        const errorInfo = i18n.t('tim.Failed to initialize streaming group') + i18n.t('tim.Refresh and try again');
        console.log("--------------------------------");
        this.$message.error(errorInfo);
        console.error('im | login | failed', imError); // 登录失败的相关信息
      }
    },
    // 登出即时通信 IM
    async logout() {
      console.log(312312)
      try {
        await this.$tim.logout();
        console.log("登出即时通信");
      } catch (imError) {
        console.error('logout error:', imError);
      }
    },

    // ----------- 群组相关 ------------
    // 加入创建的直播群
    async joinGroup() {
      console.log("群组相关:", this.groupID, "GRP_AVCHATROOM:", TIM.TYPES.GRP_PUBLIC);
      try {
        await this.$tim.joinGroup({
          groupID: this.groupID,
          type: TIM.TYPES.GRP_AVCHATROOM,
          // type: TIM.TYPES.GRP_PUBLIC,
        });
        this.imdLogin = true;
        this.getGroupAttributes()
      } catch (error) {
        switch (error.code) {
          case 10015:
            this.$message.error(this.$t('Live admin does not exist'));
            break;
          default:
            this.$message.error(this.$t('群组不存在或已经被解散！'));
            break;
        }
        console.error('joinGroup error:', error); // 申请加群失败的相关信息
      }
    },
    // 退群
    async quitGroup() {
      console.log("groupID",this.groupID);
      try {
        await this.$tim.quitGroup(this.groupID);
      } catch (error) {
        console.error('quitGroup error:', error); // 申请退群失败的相关信息
      }
    },
    // 退群
    async quitGroupBack(groupID) {
      console.log("groupID",groupID);
      console.log("groupID",this.groupID);
      try {
        await this.$tim.quitGroup(groupID);
      } catch (error) {
        console.error('quitGroup error:', error); // 申请退群失败的相关信息
      }
    },
    // 判断群组是否存在
    async searchGroup() {
      console.log("判断群组是否存在-------------")
      console.log(this.$tim)
      console.log(1111,this.groupID);
      try {
        // 判断群组是否存在
       let resGroupB = await this.$tim.searchGroupByID(this.groupID);
        this.$nextTick(() => {
          this.loadingInstance.close();
        });
        // 加入群组
        this.joinGroup();
      } catch (imError) {
        // 不存在的情况
        console.warn('判断群组是否存在   searchGroupByID error:', imError); // 搜素群组失败的相关信息
        await this.createGroup();
        // await this.joinGroup();
      }
    },
    // 获取群信息
    async getGroupProfile(groupId) {
      return await this.$tim.getGroupProfile({ groupID: groupId });
    },
    async isGroupByID() {
      try {
        let searchGroup =  await this.$tim.searchGroupByID(this.groupID);
        return true;
      } catch (imError) {
        // 不存在的情况
        console.warn('判断群组是否存在   searchGroupByID error:', imError); // 搜素群组失败的相关信息
      }
      return  false;
    },
    //获取群的属性
    async getGroupAttributes(groupId) {
      try {
         let imResponses = await this.$tim.getGroupAttributes({
          groupID: this.groupID,
          keyList: [],
        })
        console.log(imResponses.data.groupAttributes);
        let arr=imResponses.data.groupAttributes[ Object.keys(imResponses.data.groupAttributes).sort().pop() ]
         console.log("获取群的属性", JSON.parse(arr));
         
         this.call_voteList(JSON.parse(arr))
        
      } catch (error) {
        
      }
    },
    // 创建群组
    async createGroup() {
       alert("该房间未开播");
       this.routerWatch();
      // try {
      //   await this.$tim.createGroup({
      //     type: TIM.TYPES.GRP_AVCHATROOM,
      //     name: this.roomName,
      //     groupID: this.groupID,
      //   });
      // } catch (imError) {
      //   console.error('createGroup error:', imError);
      //   this.$message.error(i18n.t('tim.Failed to create streaming group')); // 创建群组失败的相关信息
      // }
    },
    // ----------- 收发消息相关 ----------
    // 监听事件
    handleTimEvents() {
      // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
      console.log("监听事件  开始  到这里没有--------------")
      this.$tim.on(TIM.EVENT.SDK_READY, this.onReadyStateUpdate);
      // SDK NOT READY
      this.$tim.on(TIM.EVENT.SDK_NOT_READY, this.onNotReadyStateUpdate);
      // 被踢出
      this.$tim.on(TIM.EVENT.KICKED_OUT, this.onKickOut);
      // SDK内部出错
      this.$tim.on(TIM.EVENT.ERROR, this.onError);
      // 收到新消息
      this.$tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.onTextMessageReceived);
      console.log(this.$tim);
      console.log("到这里没有--------------")
    },
    // SDK READY
    async onReadyStateUpdate({ name }) {
      // 修改个人标配资料
      console.log("-------修改个人标配资料-----------")
      const isSDKReady = name === TIM.EVENT.SDK_READY;
      if (isSDKReady) {
        this.isSdkReady = true;
        this.$tim.getMyProfile();// 获取个人资料
        // 修改个人标配资料
        try {
          await this.$tim.updateMyProfile({
            nick: this.userInfo.userName,
            avatar: this.userInfo.userAvatar || '',
            gender: TIM.TYPES.GENDER_FEMALE,
            selfSignature: '',
            allowType: TIM.TYPES.ALLOW_TYPE_ALLOW_ANY,
            role:4,
          });
        } catch (imError) {
          console.error('updateMyProfile error:', imError); // 更新资料失败的相关信息···
        }
        this.searchGroup();// 判断群组是否已经存在
      }
    },
    // SDK NOT READY
    onNotReadyStateUpdate() {
      this.$message.warn('该用户已经在其他地方登录！');
    },
    // 接收文本消息
    onTextMessageReceived(event) {
      const messageList = event.data;
      console.log('event',event);
      messageList.forEach((message) => {
        console.log("message",message)

        if (message.type === TIM.TYPES.MSG_TEXT) {
          let msg = {
            nick: message.nick || message.from,
            content: message.payload.text,
            renderContent: decodeText(message.payload.text),
            userID: message.from,
            userAvatar: message.avatar,
            time: message.time,
            type:2,
          };
          this.call_imMessage(msg)
        } else if (message.type == TIM.TYPES.MSG_GRP_SYS_NOTICE) {
          console.log("系统推送消息")
          let messageuserDefinedField=JSON.parse(message.payload.userDefinedField)
          // console.log(messageuserDefinedField);
          
          if(message.payload.userDefinedField && messageuserDefinedField.msgType=="msg_question"){
            // this.$store.commit(UPDATE_VOTE_LTST,message.payload.userDefinedField);
            console.log(message.payload.userDefinedField);
            console.log('-------------走到这里存储--------');
            this.call_voteList(JSON.parse(message.payload.userDefinedField))
          }else if(messageuserDefinedField.msgType=="msg_hot_online"){
            this.call_hotOnline(messageuserDefinedField.msgContent)
          }else if(messageuserDefinedField.msgType=="msg_live_start"){
              this.call_playback(messageuserDefinedField.msgContent)
          }else if(messageuserDefinedField.msgType=="live_scene"){
                this.call_liveScene(messageuserDefinedField.msgContent)
          }

          this.$store.commit(UPDATE_SWITCH_VOTE, true);
          //结束直播群组解散的时候
          if (message.payload.operationType == 5){
            (function(){
              window.alert = function(name){
              var iframe = document.createElement("IFRAME");
              iframe.style.display="none";
              iframe.setAttribute("src", 'data:text/plain');
              document.documentElement.appendChild(iframe);
              window.frames[0].window.alert(name);
              iframe.parentNode.removeChild(iframe);
              }

              })();
              alert("直播已结束!");
              this.routerWatch();

          }
        }
      });
      this.messageList = this.get_imMessageList;

    },
    // 发送消息
    async sendMessage(msgText) {
      // 创建消息并发送到对应群组
      const messageItem = {
        nick: this.userInfo.userName || '',
        content: msgText,
        renderContent: decodeText(msgText),
        userID: this.userInfo.userId,
        time: Number(Date.now().toString()
          .substr(0, 10)),
        userAvatar:this.userInfo.userAvatar,
        type:1,
      };
      try {
        const message = await this.$tim.createTextMessage({
          to: this.groupID,
          conversationType: TIM.TYPES.CONV_GROUP,
          payload: {
            text: msgText,
          },
        });
        try {
          await this.$tim.sendMessage(message);
          messageItem.state = 'success';
        } catch (imError) {
          messageItem.state = 'fail';
          // 发送失败
          switch (imError.code) {
            case 10017:
              this.$message.error(i18n.t('tim.Currently forbidden to send messages'));
              break;
            default:
              this.$message.error(i18n.t('tim.Failed to send message'));
          }
        }
      } catch (error) {
        messageItem.state = 'fail';
      }
      this.call_imMessage(messageItem)
      this.messageList = this.get_imMessageList;
    },
    // 错误
    onError() {

    },
    // 被踢出
    onKickOut() {

    },
    routerWatch(){
      this.$router.push({
        path: 'watch',
        query: {
          userId: this.$route.query.userId,
          roomId: this.$route.query.roomId,
        }
      });
    },
    beforeunloadHandler(e) {
        this.quitGroup();
        this.logout();
    },
  },
  //todo
  mounted() {
    // 关闭浏览器执行退出接口
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('beforeCreate', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
  },
  destroyed() {
    // 关闭浏览器执行退出接口
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
    window.removeEventListener('beforeCreate', e => this.beforeunloadHandler(e));
    window.removeEventListener('unload', e => this.unloadHandler(e))
  },
};
